import { render, staticRenderFns } from "./commonList.vue?vue&type=template&id=188f0d96&scoped=true&"
import script from "./commonList.vue?vue&type=script&lang=js&"
export * from "./commonList.vue?vue&type=script&lang=js&"
import style0 from "./commonList.vue?vue&type=style&index=0&id=188f0d96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f0d96",
  null
  
)

export default component.exports